import {
  Avatar,
  AvatarFallback,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@e2n/ui';
import { Manager } from '@/domain/mitarbeiter/features/anlageassistent/entities/Manager';
import { useManager } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useManager/useManager';
import { useStandortContext } from '@/features/standortContext/StandortContext';

export function AvatarBox({ managerIds }: { managerIds: string[] }) {
  const { currentStandort } = useStandortContext();
  const { manager } = useManager(currentStandort.id);

  const mappedManagers = managerIds
    .map((id) => manager.find((m) => m.id === id))
    .filter((m): m is Manager => !!m);
  const displayedManagers = mappedManagers.slice(0, 4);
  const remainingManagers = mappedManagers.slice(4);
  return (
    <div className="flex flex-row">
      {displayedManagers.map((m) => {
        return (
          <div key={m.id} className="not-first:-ml-1">
            <AvatarWrapper
              trigger={
                <Avatar className="size-8 ring-3 ring-white group-hover:ring-slate-100">
                  <AvatarFallback>{`${m.vorname.charAt(0).toUpperCase()}${m.nachname.charAt(0).toUpperCase()}`}</AvatarFallback>
                </Avatar>
              }
              content={<span>{`${m.vorname} ${m.nachname}`}</span>}
            />
          </div>
        );
      })}
      {remainingManagers.length > 0 && (
        <div key={remainingManagers[0].id} className="not-first:-ml-1">
          <AvatarWrapper
            trigger={
              <Avatar className="size-8 ring-3 ring-white group-hover:ring-slate-100">
                <AvatarFallback>{`+${remainingManagers.length}`}</AvatarFallback>
              </Avatar>
            }
            content={
              <div className="flex flex-col gap-2">
                {remainingManagers.map((m) => (
                  <div className="flex gap-2 items-center" key={m.id}>
                    <Avatar className="size-8">
                      <AvatarFallback>{`${m.vorname.charAt(0).toUpperCase()}${m.nachname.charAt(0).toUpperCase()}`}</AvatarFallback>
                    </Avatar>
                    <span>{`${m.vorname} ${m.nachname}`}</span>
                  </div>
                ))}
              </div>
            }
          />
        </div>
      )}
    </div>
  );
}

function AvatarWrapper({
  trigger,
  content,
}: {
  trigger: React.ReactNode;
  content: React.ReactNode;
}) {
  return (
    <>
      <Popover>
        <PopoverTrigger className="flex md:hidden">{trigger}</PopoverTrigger>
        <PopoverContent className={`bg-white p-2 w-fit`} side="bottom">
          {content}
        </PopoverContent>
      </Popover>
      <Tooltip>
        <TooltipTrigger className="hidden md:flex">{trigger}</TooltipTrigger>
        <TooltipContent className={`bg-white p-2`} side="bottom">
          {content}
        </TooltipContent>
      </Tooltip>
    </>
  );
}
